import { FunctionComponent } from 'react';
import styles from './ServiceTypeTag.module.scss';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHotel, faScissors, faTennisBall, faDogLeashed, faWhistle } from '@fortawesome/pro-regular-svg-icons';
import { faStar, faVanShuttle } from '@fortawesome/pro-light-svg-icons';

interface ServiceTypeTagProps {
    name: string;
    selected: boolean;
    onSelect: () => void;
    className?: string;
}

export const ServiceTypeTag: FunctionComponent<ServiceTypeTagProps> = props => {
    const getIcon = () => {
        switch (props.name) {
            case 'memberships':
                return <FontAwesomeIcon icon={faStar} />;
            case 'grooming':
                return <FontAwesomeIcon icon={faScissors} />;
            case 'daycare':
                return <FontAwesomeIcon icon={faTennisBall} />;
            case 'boarding':
                return <FontAwesomeIcon icon={faHotel} />;
            case 'transportation':
                return <FontAwesomeIcon icon={faVanShuttle} />;
            case 'walking':
                return <FontAwesomeIcon icon={faDogLeashed} />;
            case 'training':
                return <FontAwesomeIcon icon={faWhistle} />;
        }
    };

    return (
        <div
            className={clsx(styles.tagContainer, props.className, {
                [styles.selected]: props.selected
            })}
            onClick={props.onSelect}
        >
            {getIcon()}
            <span className={styles.text}>{props.name.charAt(0).toUpperCase() + props.name.slice(1)}</span>
        </div>
    );
};

export default ServiceTypeTag;
